import { useState, useCallback } from 'react';

export const useTextState = (cardPreset) => {
  const [currentTextLayers, setCurrentTextLayers] = useState({
    front: [],
    back: [],
  });
  const [selectedTextId, setSelectedTextId] = useState(null);
  const [isEditingText, setIsEditingText] = useState(false);

  const selectedTextLayer = currentTextLayers.front.find(t => t.id === selectedTextId) ||
                           currentTextLayers.back.find(t => t.id === selectedTextId) ||
                           null;

  const addTextLayer = useCallback((text, side = 'front') => {
    const newLayer = {
      id: `text-${Date.now()}`,
      text,
      x: 50,
      y: 50,
      fontSize: 16,
      color: '#000000',
      fontFamily: 'Arial',
      side,
    };
    setCurrentTextLayers(prev => ({
      ...prev,
      [side]: [...prev[side], newLayer],
    }));
    return newLayer;
  }, []);

  const addTextLayerToSide = useCallback((text, side) => {
    return addTextLayer(text, side);
  }, [addTextLayer]);

  const updateTextLayer = useCallback((id, updates) => {
    setCurrentTextLayers(prev => ({
      front: prev.front.map(t => t.id === id ? { ...t, ...updates } : t),
      back: prev.back.map(t => t.id === id ? { ...t, ...updates } : t),
    }));
  }, []);

  const removeTextLayer = useCallback((id) => {
    setCurrentTextLayers(prev => ({
      front: prev.front.filter(t => t.id !== id),
      back: prev.back.filter(t => t.id !== id),
    }));
  }, []);

  const selectTextLayer = useCallback((id) => {
    setSelectedTextId(id);
  }, []);

  const deselectText = useCallback(() => {
    setSelectedTextId(null);
    setIsEditingText(false);
  }, []);

  const switchTextSide = useCallback((side) => {
    // Logic
  }, []);

  const moveTextLayer = useCallback((id, x, y) => {
    updateTextLayer(id, { x, y });
  }, [updateTextLayer]);

  const clearAllText = useCallback(() => {
    setCurrentTextLayers({ front: [], back: [] });
    setSelectedTextId(null);
  }, []);

  return {
    currentTextLayers,
    selectedTextId,
    selectedTextLayer,
    isEditingText,
    addTextLayer,
    addTextLayerToSide,
    updateTextLayer,
    removeTextLayer,
    selectTextLayer,
    deselectText,
    switchTextSide,
    moveTextLayer,
    setIsEditingText,
    clearAllText,
  };
};
